"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BrandItemDir_1 = require("./BrandItemDir");
var BrandAreaDir = /** @class */ (function (_super) {
    __extends(BrandAreaDir, _super);
    function BrandAreaDir(props) {
        return _super.call(this, props) || this;
    }
    BrandAreaDir.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            dirList: this.props.data.getBrandItemById(this.props.brandId).directories
        });
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                dirList: _this.props.data.getBrandItemById(_this.props.brandId).directories
            });
        });
    };
    BrandAreaDir.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            dirList: nextProps.data.getBrandItemById(nextProps.brandId).directories
        });
    };
    BrandAreaDir.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandAreaDir.prototype.onSelectDirectoryClick = function (brandId, dirName) {
        if (this.props.onSelectDirectory) {
            this.props.onSelectDirectory(brandId, dirName);
        }
    };
    BrandAreaDir.prototype.getRenderObjectList = function () {
        var _ret = [];
        for (var i = 0; i < this.state.dirList.length; i++) {
            _ret.push(React.createElement(BrandItemDir_1.default, { dirName: this.state.dirList[i].dirName, brandId: this.props.brandId, key: "dir-" + this.props.brandId + "-" + this.state.dirList[i].dirName, onSelectlick: this.onSelectDirectoryClick.bind(this) }));
        }
        return _ret;
    };
    BrandAreaDir.prototype.render = function () {
        return (React.createElement("div", { style: {
                width: "100%",
                borderColor: "black",
                borderStyle: "solid",
                borderLeftWidth: "0px",
                borderTopWidth: "1px",
                borderRightWidth: "1px",
                borderBottomWidth: "1px",
                display: "flex",
                justifyContent: "flex-start",
                alignContent: "flex-start",
                alignItems: "flex-start",
                justifyItems: "flex-start",
                flexDirection: "row",
                flexWrap: "wrap",
                overflowY: "scroll",
                overflowX: "hidden"
            } }, this.getRenderObjectList()));
    };
    return BrandAreaDir;
}(React.Component));
exports.default = BrandAreaDir;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/dlgSelectBrandImage/controls/BrandAreaDir.tsx
// module id = 2392
// module chunks = 0